export const trackingResources = {
  'tracking.tableColumns.carrierStatusMessage': 'Carrier Status Message',
  'tracking.tableColumns.eventDateTime': 'Event Time',
  'tracking.tableColumns.deliveryStep': 'Delivery Step',
  'tracking.tableColumns.eventCity': 'City',
  'tracking.tableColumns.eventRegion': 'Region',
  'tracking.tableColumns.eventPostalCode': 'Postal Code',
  'tracking.tableColumns.status': 'Status',
  'tracking.tableColumns.trackingId': 'Tracking ID',
  'tracking.tableColumns.carrierServiceMethod': 'Carrier Service Method',
  'tracking.tableColumns.shippedDateTime': 'Shipped Timestamp',
  'tracking.tableColumns.deliveredDateTime': 'Delivered Timestamp',
  'tracking.tableColumns.labelPrintedDateTime': 'Printed Timestamp',
  'tracking.tableColumns.estimatedDeliveryDateTime': 'Estimated Delivery Date',
  'tracking.getTrackingForm.carrierName': 'Carrier Name',
  'tracking.getTrackingForm.title': 'Get Tracking Information',
  'tracking.getTrackingForm.idListLabel': 'Tracking Number(s)',
  'tracking.getTrackingForm.idListExtra': 'Provide up to 100 tracking numbers that are space, comma or line separated.',
  'tracking.getTrackingForm.idListError': 'Please provide a maximum of 100 tracking numbers',
  'tracking.selectTrackingMessage': 'Select a carrier and tracking id(s)',
  'tracking.selectDifferentTrackingMessage': 'Select Different Set of Trackings',
  'tracking.noSelectedTracking': 'No selected tracking info',
  'tracking.viewDetails': 'View Details',
};
export type TrackingResourceKey =
  | 'tracking.tableColumns.carrierStatusMessage'
  | 'tracking.tableColumns.eventDateTime'
  | 'tracking.tableColumns.deliveryStep'
  | 'tracking.tableColumns.eventCity'
  | 'tracking.tableColumns.eventRegion'
  | 'tracking.tableColumns.eventPostalCode'
  | 'tracking.tableColumns.status'
  | 'tracking.tableColumns.trackingId'
  | 'tracking.tableColumns.shippedDateTime'
  | 'tracking.tableColumns.deliveredDateTime'
  | 'tracking.tableColumns.carrierServiceMethod'
  | 'tracking.tableColumns.estimatedDeliveryDateTime'
  | 'tracking.tableColumns.labelPrintedDateTime'
  | 'tracking.getTrackingForm.carrierName'
  | 'tracking.getTrackingForm.title'
  | 'tracking.getTrackingForm.idListLabel'
  | 'tracking.getTrackingForm.idListExtra'
  | 'tracking.getTrackingForm.idListError'
  | 'tracking.selectTrackingMessage'
  | 'tracking.selectDifferentTrackingMessage'
  | 'tracking.noSelectedTracking'
  | 'tracking.viewDetails';
